import { useQuery, useQueryClient,useMutation } from '@tanstack/react-query';
import { useItemReviewApi } from '../../hooks/useItemReviewApi';
import { useSnackbar } from '../Stateless/SnackBarProvider';


export const useReviewApprove = () => {
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { getToggleStatus } = useItemReviewApi();

  return useMutation({
    mutationKey: ['toggleReview'],
    mutationFn: ({ id, data }: { id: string[]; data: any }) =>
      getToggleStatus({ id, status: data.status }),
    onSuccess: (_response, variables) => {
      const action =
        variables.data.status === true ? 'Approved' : 'Disapproved';
      showMessage(`Review ${action} successfully`, 'success');
      queryClient.invalidateQueries({
        queryKey: ['getReview'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.detail?.[0]?.type
      );
    },
  });
};

export const useDeleteReview = () => {
  const queryClient = useQueryClient();
  const { deleteReview } = useItemReviewApi();
  const { showMessage } = useSnackbar();

  return useMutation({
    mutationKey: ['DeleteReview'],
    mutationFn: (ids: string[]) => {
      return deleteReview(ids);
    },
    onSuccess: (response: any) => {
      showMessage(
        response?.message || 'Review deleted successfully',
        'success'
      );
      queryClient.invalidateQueries({
        queryKey: ['getReview'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.message || 'Failed to deleted Review',
        'error'
      );
    },
  });
};
type Params = {
  sortBy?: string;
  sortOrder?: string;
  page?: number;
  limit?: number;
  addedByFilter?: string;
  statusFilter?: string;
  search?: string;
};

export const useAllItemReview = (queryParams: Params) => {

  const { getAllItemReview } = useItemReviewApi();
  const {
    data,
    isLoading: isFetching,
    refetch,
    isRefetching,
  } = useQuery({
    queryKey: ['getReview',queryParams],
    queryFn: () => {
      return getAllItemReview(queryParams);
    },
  });

  const isLoading = isFetching || isRefetching;

  return {
    data,
    isLoading,
    refetch
  };
};

